import { SxProps, Theme } from '@mui/material';

export const peopleGroupBoxSx: SxProps<Theme> = {
  display: 'flex',
  gap: 0.5,
  alignItems: 'center',
};

export const personAvatarWrapperSx: SxProps<Theme> = {
  position: 'relative',
  width: 32,
  height: 32,
  flexShrink: 0,
  overflow: 'visible',
};

export const personAvatarDimensionsSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  fontSize: '1rem',
  fontWeight: 'bolder',
};

export const personExtraCountBadgeSx: SxProps<Theme> = {
  position: 'absolute',
  bottom: -3,
  right: -3,
  minWidth: 18,
  height: 16,
  px: 0.35,
  borderRadius: 999,
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
  fontSize: '0.58rem',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
  border: '1.5px solid',
  borderColor: 'background.paper',
  boxSizing: 'border-box',
};

export const tooltipSx: SxProps<Theme> = {
  bgcolor: 'background.paper',
  color: 'text.primary',
  boxShadow: 4,
  border: '1px solid',
  borderColor: 'divider',
};

export const tooltipArrowSx: SxProps<Theme> = {
  color: 'background.paper',
};

export const peopleTooltipContentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
};
